import { LienholderSlugEnum } from '../gql/generated/graphql';
import { isTreatedAsOther } from './lienholders';

export type Competitor = 'carvana' | 'carmax';

export const CARVANA_LEASE_POLICY_URL =
  'https://www.carvana.com/help/sell-or-trade/will-you-buy-out-my-leased-vehicle/';
export const CARMAX_LEASE_POLICY_URL =
  'https://www.carmax.com/faq/selling-a-car/does-carmax-buy-leased-cars';

// Carvana's published approved-lender list as of 2026-07-22, limited to lienholders we have slugs for.
export const CARVANA_APPROVED_LIENHOLDERS = new Set<string>([
  LienholderSlugEnum.ChaseAutoFinance,
  LienholderSlugEnum.ChrystlerCapitalCcap,
  LienholderSlugEnum.LandRoverFg,
  LienholderSlugEnum.LexusFinancialServices,
  LienholderSlugEnum.MazdaFinancialServices,
  LienholderSlugEnum.MclarenFinancialServices,
  LienholderSlugEnum.MercedesBenzFs,
  LienholderSlugEnum.PorchePaymentCenter,
  LienholderSlugEnum.SubaruMotorFinance,
  LienholderSlugEnum.Toyota,
]);

// CarMax's published cannot-purchase list as of 2026-07-22; values are CarMax's wording for the text-fragment anchor.
export const CARMAX_EXCLUDED_LIENHOLDERS: Partial<Record<LienholderSlugEnum, string>> = {
  [LienholderSlugEnum.AcuraFinancialServices]: 'Acura Financial',
  [LienholderSlugEnum.Ally]: 'Ally Financial',
  [LienholderSlugEnum.AudiFinancialServices]: 'Audi Financial Services',
  [LienholderSlugEnum.BmwFs]: 'BMW Financial Services',
  [LienholderSlugEnum.FordMotorCredit]: 'Ford Credit',
  [LienholderSlugEnum.GmFinancial]: 'GM Financial',
  [LienholderSlugEnum.HondaFinancialServices]: 'Honda Finance',
  [LienholderSlugEnum.MazdaFinancialServices]: 'Mazda Credit',
  [LienholderSlugEnum.NissanFinance]: 'Nissan Motor Acceptance',
  [LienholderSlugEnum.SeToyota]: 'Southeast Toyota Financial',
  [LienholderSlugEnum.TeslaFinance]: 'Tesla',
  [LienholderSlugEnum.VolkswagenCredit]: 'Volkswagen Credit',
  [LienholderSlugEnum.VolvoCarFs]: 'Volvo Financial',
};

export type CompetitorBucket = 'bothCannot' | 'carvanaCannot' | 'carmaxCannot' | 'bothCan';

export const getCompetitorBucket = (slug: string): CompetitorBucket | null => {
  if (isTreatedAsOther({ lienholder_slug: slug })) return null;
  if (!Object.values(LienholderSlugEnum).includes(slug as LienholderSlugEnum)) return null;
  const carvanaCan = CARVANA_APPROVED_LIENHOLDERS.has(slug);
  const carmaxCan = CARMAX_EXCLUDED_LIENHOLDERS[slug as LienholderSlugEnum] == null;
  if (carvanaCan && carmaxCan) return 'bothCan';
  if (!carvanaCan && !carmaxCan) return 'bothCannot';
  return carvanaCan ? 'carmaxCannot' : 'carvanaCannot';
};
